import classNames from 'classnames';
import React from 'react';
import SubtractIcon from './assets/minus.svg';
import AddIcon from './assets/plus.svg';
import styles from './Counter.module.scss';

interface ICounterProps {
  max?: number;
  min?: number;
  className?: string;
  activeClassName?: string;
  disabled?: boolean;
  count: number;
  onCountChange?: (count: number) => void;
}

export default function Counter({
  max,
  min = 0,
  className,
  disabled,
  count,
  activeClassName,
  onCountChange = () => {}
}: ICounterProps) {
  const handleDecrease = () => {
    const newCount = count - 1;
    if (min <= newCount) {
      onCountChange(newCount);
    }
  };

  const handleIncrease = () => {
    const newCount = count + 1;
    if (!max || max >= newCount) {
      onCountChange(newCount);
    }
  };

  return (
    <div className={`${styles.Counter} ${className ?? ''}`}>
      <button
        className={classNames(
          styles.Decrement,
          `${count !== min ? activeClassName : ''}`
        )}
        type="button"
        onClick={handleDecrease}
        disabled={disabled}
        aria-label="One less room"
      >
        <SubtractIcon />
      </button>
      <div className={styles.Value}>{count}</div>
      <button
        className={classNames(
          styles.Increment,
          `${count !== max ? activeClassName : ''}`
        )}
        type="button"
        aria-label="One more room"
        onClick={handleIncrease}
        disabled={disabled}
        data-test="counter-increment"
      >
        <AddIcon />
      </button>
    </div>
  );
}
